import React from "react";

const SectorCard = ({ title, icon, desc }) => {
  return (
    <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 hover:border-blue-400 hover:shadow-lg transition-all duration-300 cursor-default">
      <div className="text-3xl mb-4">{icon}</div>
      <h4 className="font-bold text-slate-900 mb-1">{title}</h4>
      <p className="text-xs text-slate-500">{desc}</p>
    </div>
  );
};

const DatabaseSection = () => {
  return (
    <section className="py-24 bg-white text-slate-800 border-b border-slate-100">
      <div className="container mx-auto px-6 max-w-screen-xl">
        <div className="flex flex-col md:flex-row items-center gap-16 mb-20">
          {/* DESCRIPTION TEXT*/}
          <div className="md:w-1/2">
            <span className="text-blue-600 font-bold tracking-wider uppercase text-sm">
              Data Management
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6 text-slate-900">
              Structured Data for <br />
              <span className="text-blue-600">Retail & Services</span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              We design centralized database systems for sectors where speed and
              accuracy are vital. Manage inventory, sales, and customer history
              in real-time.
            </p>
            <ul className="space-y-3 text-slate-600">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Instant Inventory Updates
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Automated Reporting
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Cloud-Based Backups
              </li>
            </ul>
          </div>

          <div className="md:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <SectorCard
              title="Pharmacies"
              icon="🏥"
              desc="Patient records & drug stock."
            />
            <SectorCard
              title="Schools"
              icon="🏫"
              desc="Student grades & attendance."
            />
            <SectorCard
              title="Supermarkets"
              icon="🛒"
              desc="POS systems & supply chain."
            />
            <SectorCard
              title="Hotels"
              icon="🏨"
              desc="Reservations & guest billing."
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DatabaseSection;
